'use client';

import type { TranslationSnapshotBoundaryComponent } from '@eliadmin/core/src/i18n/translation-snapshot-types';
import dynamic from 'next/dynamic';

const DictionaryBoundary0 = dynamic(() => import('./providers/dictionary-89b12f6345b52d31f086bfa12a9380e4df9bd3a4403770156858718b365f8085'));
const DictionaryBoundary1 = dynamic(() => import('./providers/dictionary-a62c2d3691974441a9f8493e7dd64fccbc07508ce33b70b0580eb7692fe86da3'));
const DictionaryBoundary2 = dynamic(() => import('./providers/dictionary-6f0f504758f319af60d914631457f7639656f7ec70a9fde673bbbdc695436226'));
const DictionaryBoundary3 = dynamic(() => import('./providers/dictionary-7af93f13990d3659ba46c4a8c5adbf0bc394e782898d13ad28bae2024b7ef3aa'));
const DictionaryBoundary4 = dynamic(() => import('./providers/dictionary-7aeab3f66141785e5c6ff4e96fd7279a5a39843616512d93b9c6ed7adc08f4fc'));
const DictionaryBoundary5 = dynamic(() => import('./providers/dictionary-848705ad8468c6ac3a5652e4cdf33b9e5464cc5f9e9209ef89fa2eb4c4a342d1'));
const DictionaryBoundary6 = dynamic(() => import('./providers/dictionary-dc5cefa0f86a717c300d525e2c079b7a481d7bd918b07c8d83399164269eaa03'));
const DictionaryBoundary7 = dynamic(() => import('./providers/dictionary-133df795d4804cd493018c615724c5486863056285040576e9b429c64a31fd29'));
const DictionaryBoundary8 = dynamic(() => import('./providers/dictionary-6a1259ed8e03d2c2e00e847b28a64d4c8aba52f2b7e196d4c354dac54b31fe79'));

export const GENERATED_TRANSLATION_BOUNDARIES: Readonly<Record<string, TranslationSnapshotBoundaryComponent>> = {
  "sk": DictionaryBoundary0,
  "en": DictionaryBoundary1,
  "pl": DictionaryBoundary2,
  "hu": DictionaryBoundary3,
  "es": DictionaryBoundary4,
  "fr": DictionaryBoundary5,
  "it": DictionaryBoundary6,
  "de": DictionaryBoundary7,
  "ru": DictionaryBoundary8,
};
